import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Line from "./components/Common/Line.vue";
import Header from "./components/Common/Header.vue";
import Footer from "./components/Common/Footer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass(_ctx.$route.meta.bodyClass)
  }, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Line),
    _createVNode(Footer)
  ], 2))
}
}

})